(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-newsletter"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-mvps-news-form]').forEach((form) => {
    const root = form.closest('.blog-nl-mvps-newsletter');
    const ok = root.querySelector('[data-mvps-news-ok]');
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const input = form.querySelector('input[type="email"]');
      if (!input || !input.checkValidity()) {
        input?.reportValidity();
        return;
      }
      form.hidden = true;
      ok.hidden = false;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-blog-grid"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sections = document.querySelectorAll('[data-mvps-blog-grid]');
  sections.forEach((grid) => {
    const root = grid.closest('.blog-bg-mvps-blog-section');
    const input = root.querySelector('[data-mvps-blog-input]');
    const form = root.querySelector('[data-mvps-blog-search]');
    const filters = root.querySelectorAll('[data-filter]');
    const cards = grid.querySelectorAll('.blog-bg-post-card');
    const noResults = root.querySelector('[data-mvps-no-results]');
    const clear = root.querySelector('[data-mvps-clear]');
    let active = 'All';

    const apply = () => {
      const q = (input.value || '').trim().toLowerCase();
      let count = 0;
      cards.forEach((card) => {
        // Match against data-tags (all tags) instead of just data-category
        const cardTags = (card.dataset.tags || card.dataset.category || '').split(',').map(t => t.trim());
        const categoryMatch = active === 'All' || cardTags.includes(active);
        const textMatch = !q || (card.dataset.search || '').toLowerCase().includes(q);
        const visible = categoryMatch && textMatch;
        card.classList.toggle('blog-bg-is-hidden', !visible);
        if (visible) count += 1;
      });
      noResults.hidden = count !== 0;
    };

    form.addEventListener('submit', (event) => event.preventDefault());
    input.addEventListener('input', apply);
    filters.forEach((button) => {
      button.addEventListener('click', () => {
        active = button.dataset.filter;
        filters.forEach((item) => item.classList.toggle('blog-bg-active', item === button));
        apply();
      });
    });
    clear.addEventListener('click', () => {
      input.value = '';
      active = 'All';
      filters.forEach((item) => item.classList.toggle('blog-bg-active', item.dataset.filter === 'All'));
      apply();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
